import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Search,
  DataTable,
  Loading,
  DataTableSkeleton,
  TextInput,
  TableContainer,
  Pagination,
  Form,
  FormLabel,
  FormGroup,
  TableHead,
  Table,
  Dropdown,
  DropdownSkeleton,
  TableSelectRow,
  TableBatchActions,
  TableBatchAction,
  TableBody,
  TableRow,
  TableCell,
  TableHeader,
  TableToolbar,
  TableToolbarContent,
  Button,
} from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Send16 from '@carbon/icons-react/lib/send/16';
import {
  CheckmarkOutline16,
  Add20,
  Error16,
  DocumentExport16,
} from '@carbon/icons-react/lib/';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import TrainingRepository from '../../helpers/api/TrainingRepository';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  STATUS,
} from '../../helpers/Constants';
import { training, me, api } from '../../helpers/api/api';
import { ComboBox } from '../../helpers/ComboBox';
import { CanExecuteAction, IsInRole } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import { WFActionModal } from '../common/WFActionModal';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { Online, Offline } from '../common/OnLineOffLine';
import FileDownLoadButton from '../common/FileDownloadButton';
import SortIcon from '../common/SortIcon';


const defaultOrderBy = {
  orderByField: 'startDate',
  isOrderDescending: true
};

export default class TrainingList extends Component {
  constructor(props) {
    super(props);
    this.year = new Date().getFullYear();

    this.state = {
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      isLoadingNotificationFile: false,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      itemList: [],
      worksite: [],
      status: [],
      country: [],
      maindivision: [],
      trainingYear: [],
      month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      prj: [],
      company: [],
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      isBack:
        !!(this.props.history.action === 'POP' || this.props.location.search === '?isBack'),
      searchModel: {
        ...this.searchProp(),
      },
    };
    this.toggleSearchForm = this.toggleSearchForm.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.getUserWorksite = this.getUserWorksite.bind(this);
    this.getCountry = this.getCountry.bind(this);
    this.getCompany = this.getCompany.bind(this);
    this.getTrainingList = this.getTrainingList.bind(this);
    this.IsRowSelectable = this.IsRowSelectable.bind(this);
    this.getTrainingYears = this.getTrainingYears.bind(this);
  }

  componentDidMount() {
    this.getTrainingList();
    this.getCountry();
    this.getCompany();
    this.getPrj();
    this.getUserWorksite();
    this.getStatus();
    this.getTrainingYears();
    this.getUserDivision();
  }

  /** ***********API get all Training******************* */
  getTrainingList = async (param) => {
    let data = null;
    this.setState({
      isLoading: true,
    });
    if (!this.state.isBack) {
      data = {
        params: {
          ...this.state.searchModel,
          page: param?.page || this.state.currentPage,
          pageSize: param?.pageSize || this.state.pageSize,
        },
      };
    } else {
      const filter = await TrainingRepository.getBackPaged();
      // filter.params.page = param?.page || filter.params.page;
      // RITM0549692
      filter.params.page = 1; 
      filter.params.pageSize = param?.pageSize || filter.params.pageSize;
      data = {
        params: filter.params,
      };
      this.setState({
        searchModel: filter?.params,
      });
      if (
        filter.params.idStatus === undefined &&
        filter.params.idWorksite === undefined &&
        filter.params.idCountry === undefined &&
        filter.params.idPrj === undefined &&
        filter.params.idCompany === undefined &&
        filter.params.idMainDivision === undefined &&
        filter.params.inUse === undefined &&
        filter.params.code === undefined &&
        filter.params.courseCode === undefined &&
        filter.params.compiler === undefined &&
        filter.params.dataApprover === undefined &&
        filter.params.year === undefined &&
        filter.params.month === undefined &&
        filter.params.divisionManager === undefined
      ) {
        this.setState({ isOpenSearchForm: false });
      } else {
        this.setState({ isOpenSearchForm: true });
      }
    }
    this.getTrainingListFilter(data);
  };

  getTrainingListFilter(data) {
    training
      .getWithParam(data)
      .then((response) => {
        this.setState({
          ...response.data,
        });
        TrainingRepository.updateReportFilter(data);
        TrainingRepository.updateReport(data);
      })
      .catch((error) => {
        showNotification.error(getError(error, entitiesLabels.TRAINING, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  /** ***********API******************* */
  searchProp = () => ({
    idStatus: null,
    idWorksite: null,
    idCountry: null,
    idPrj: null,
    idCompany: null,
    idMainDivision: null,
    inUse: null,
    code: null,
    courseCode: null,
    year: this.state?.searchModel?.year ? this.state?.searchModel?.year : this.year,
    month: null,
    compiler: null,
    dataApprover: null,
    divisionManager: null,
    ...defaultOrderBy
  });

  // Carico prop per combobox

  // Country
  getCountry = () => {
    api
      .getAll('/admin/country?page=0')
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          country: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.COUNTRY, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingCountry: false,
        });
      });
  };

  // Training Years
  getTrainingYears = () => {
    api.getAll('/training/years')
    .then((response) => {
      this.setState({
        trainingYear: response.data
      });
    })
    .catch((error) => {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.YEAR, apioperation.GET)
      );
    })
    .finally(() => {
      this.setState({
        isLoadingYear: false,
      });
    });
  };

  getPrj = () => {
    me.getAll('project')
      .then((response) => {
        const { data } = response;
        this.setState({
          prj: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PROJECT, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingProject: false,
        });
      });
  };

  // COMPANY
  getCompany = () => {
    api
      .getAll('/company')
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          company: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.COMPANY, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingCompany: false,
        });
      });
  };

// STATUS
getStatus = () => {
    api
        .getAll('/registry/status')
        .then((response) => {
            // DEV_255_RITM0565449
            const { data } = response;
            this.setState({
                status: data.filter((stato) => stato.id !== 3)
            });
        })
        .catch((error) => {
            showNotification.error(
                `${entitiesLabels.ERROR}`,
                getError(error, entitiesLabels.STATUS, apioperation.GET)
            );
        })
        .finally(() => {
            this.setState({
                isLoadingStatus: false,
            });
        });
};

  // Division
  getUserDivision = () => {
    me.getAll('divisions')
      .then((response) => {
        this.setState({
          maindivision: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.DIVISION, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingMainDivision: false,
        });
      });
  };

  // Worksite
  getUserWorksite = () => {
    me.getAll('worksites')
      .then((response) => {
        this.setState({
          worksite: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.WORKSITEGROUP, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingWorksite: false,
        });
      });
  };

  // /WF
  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };


  getUsersInRole = (role, idEntity) => {
    me.getWithParam('users', {
      params: { Role: role, IdEntity: idEntity, includeAdmins: true },
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROLE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: this.state.selectedData.map((r) => r.id),
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/training/${apiEndpoint}`, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.TRAINING, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isLoading: true,
            itemList: [],
          });
          this.getTrainingList();
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.TRAINING, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  getTraining = (selectedRows) => {
    if (selectedRows && selectedRows.length > 0) {
      return this.state.itemList.find((el) => el.id === selectedRows[0].id);
    }
    return null;
  };

  getStatusId = (idRow) => {
    const r = this.state.itemList.find((el) => el.id === idRow);
    return r && r.idStatus;
  };

  // Search
  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    statusCopy.isBack = false;
    // statusCopy['selectedItemCombo'][inputName] = selectedItem;
    this.setState(statusCopy);
  };

  handleChangeDropDownYear = (evt) => {
    const statusCopy = { ...this.state };
    statusCopy.searchModel.year = evt.selectedItem;
    statusCopy.isBack = false;
    this.setState((prevState) => ({ isBack: statusCopy.isBack, 
      searchModel: { ...prevState.searchModel, 
        year: statusCopy.searchModel.year, 
        month: evt.selectedItem ? prevState.searchModel.month : null } }), this.getTrainingList);
  };

  handleChangeMonth = (inputName, selectedItem,) => {
    const item = selectedItem ? this.state.month.indexOf(selectedItem) : null;
    const m = selectedItem ? (item + 1).toString() : null;
    this.setState((prevState) => (
      { searchModel: { ...prevState.searchModel, month: m } }
    ));
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    statusCopy.isBack = false;
    this.setState(statusCopy);
  };

  handleChangeSearch = (el) => {
    const inputName = el.target.name;

    const inputValue = el.target.value;
    this.setState({ isBack: false });

    this.updateState(inputName, inputValue, 'searchModel');
  };

  handleClickSearch = (e) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    this.getTrainingList({ page: 1 });
  };

  handleClickCancelSearch = () => {
    this.setState({
      isBack: false,
      isLoading: true,
      searchModel: {
        ...this.searchProp(),
      },
      isOpenSearchForm: false,
    });
    const params = {
      page: 1,
      pageSize: 10,
      idStatus: null,
      idWorksite: null,
      idCountry: null,
      idPrj: null,
      idCompany: null,
      idMainDivision: null,
      inUse: null,
      code: null,
      year: this.state?.searchModel?.year ? this.state?.searchModel?.year : this.year,
      month: null,
      courseCode: null,
      compiler: null,
      dataApprover: null,
      divisionManager: null,
      ...defaultOrderBy
    };
    this.getTrainingListFilter({ params });
  };

  handleChangePaging =async (event) => {
    await this.setState({ isBack: false });
    this.getTrainingList(event);
  };

  handleOrderByChange = (key) => {
    this.setState((prevState) => {
      const isOrderDescending = prevState.searchModel.orderByField === key
        ? !prevState.searchModel.isOrderDescending
        : true;
      return {
        isBack: false,
        searchModel: {
          ...prevState.searchModel,
          orderByField: key,
          isOrderDescending
        }
      };
    }, this.getTrainingList);
  };


IsRowSelectable(row, selectedRows, user) {
        var row = this.state.itemList.find((i) => i.id === row.id);

        if (row.idStatus == STATUS.Consolidated) return false;

        if (selectedRows.length == 0) {
            return true;
        }

        if (selectedRows.length > 0) {
            const selectableTraining = this.state.itemList.find((i) => i.id == selectedRows[0].id);
            const selectableState = selectableTraining.idStatus;
            const selectableDivision = selectableTraining.idDivision;
            const selectableWorksite = selectableTraining.idWorkSite;

            if (
                row.idStatus == selectableState &&
                (row.idStatus == STATUS.Draft
                    ? row.idWorkSite == selectableWorksite
                    : row.idDivision == selectableDivision)
            ) {
                const canSelect =
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Submit', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Approve', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Consolidate', row) ||
                    CanExecuteAction('Trainign', 'Reporting', user, row.idStatus, 'Reject', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'RejectConsolidate', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Delete', row);
                return canSelect;
                // return true;
            }

            return false;
        }

        return false;
}


  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    const trainingItem = this.state.itemList.find((i) => i.id === selectedRows[0].id);

    let idEntity;
    if (actionKey === 'Submit') {
      idEntity = trainingItem.idWorkSite;
    } else if (actionKey === 'Approve') {
      idEntity = trainingItem.idDivision;
    } else {
      idEntity = null;
    }

      this.setState({
        approvalModalAction: actionName,
        isApprovalModalOpen: true,
        isLoadingApproverOptions: true,
        withApprover,
        selectedData: selectedRows,
        approverRole,
        approvalEndpoint: actionKey,
        approvalNotesRequired,
      });

      if (withApprover) this.getUsersInRole(approverRole, idEntity);
  }

  toggleSearchForm(e) {
    e.preventDefault();
    this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
  }

  renderSearchform() {
    const filterItems = {
      idStatus: this.state.searchModel?.idStatus
        ? (this.state.status || []).find((el) => el.id === this.state.searchModel.idStatus)
        : [],
      idWorksite: this.state.searchModel?.idWorksite
        ? (this.state.worksite || []).find((el) => el.id === this.state.searchModel.idWorksite)
        : [],
      idCountry: this.state.searchModel?.idCountry
        ? (this.state.country || []).find((el) => el.id === this.state.searchModel.idCountry)
        : [],
      idMainDivision: this.state.searchModel?.idMainDivision
        ? (this.state.maindivision || []).find(
            (el) => el.id === this.state.searchModel.idMainDivision)
        : [],
      idPrj: this.state.searchModel?.idPrj
        ? (this.state.prj || []).find((el) => el.id === this.state.searchModel.idPrj)
        : [],
      idCompany: this.state.searchModel?.idCompany
        ? (this.state.company || []).find((el) => el.id === this.state.searchModel.idCompany)
        : [],
      idActionStatus: null,
      inUse: this.state.searchModel?.inUse
        ? (this.state.inUse || []).find((el) => el.id === this.state.searchModel.inUse)
        : [],
    };
    return (
      <div style={{ display: this.state.isOpenSearchForm ? 'block' : 'none' }}>
        <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel className="some-class">Status</FormLabel>
            {this.state.isLoadingStatus ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="idSearchStatus"
                placeholder="All"
                name="idStatus"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.reportingName : '')}
                initialSelectedItem={
                  this.state.searchModel?.idStatus != null ? filterItems.idStatus : 'All'
                }
                selectedItem={
                  this.state.searchModel?.idStatus != null ? filterItems.idStatus : 'All'
                }
                items={this.state.status}
              />
            )}
          </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel className="some-class">Worksite</FormLabel>
            {this.state.isLoadingWorksite ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="idSearchWorksite"
                placeholder="All"
                name="idWorksite"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={
                  this.state.searchModel?.idWorksite != null ? filterItems.idWorksite : 'All'
                }
                selectedItem={
                  this.state.searchModel?.idWorksite != null ? filterItems.idWorksite : 'All'
                }
                items={this.state.worksite}
              />
            )}
          </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel className="some-class">Project</FormLabel>
            {this.state.isLoadingProject ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="idSearchPrj"
                placeholder="All"
                name="idPrj"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={this.state.searchModel.idPrj ? filterItems.idPrj : 'All'}
                selectedItem={this.state.searchModel.idPrj ? filterItems.idPrj : 'All'}
                items={this.state.prj}
              />
            )}
          </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel className="some-class">Country</FormLabel>
            {this.state.isLoadingCountry ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="idSearchCountry"
                placeholder="All"
                name="idCountry"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={
                  this.state.searchModel.idCountry ? filterItems.idCountry : 'All'
                }
                selectedItem={this.state.searchModel.idCountry ? filterItems.idCountry : 'All'}
                items={this.state.country}
              />
            )}
          </FormGroup>

          {/* <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">
                            Reference Year
                                </FormLabel>
                        <ComboBox
                            id="idSearchReferenceYear"
                            placeholder="Select"
                            name="idReferenceYear"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={item => (item ? item.name : '')}
                            initialSelectedItem={filterItems.idReferenceYear}
                            items={this.state.referenceyear}
                        //        // items={this.state.search.search}

                        />
                    </FormGroup> */}

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel>Training Code</FormLabel>
            <TextInput
              id="inputcodesearch"
              name="code"
              value={this.state.searchModel.code || ''}
              onChange={this.handleChangeSearch}
              placeholder="Input Training Code"
              type="text"
              labelText=""
              className="bx--text-input some-class bx--text-input--light"
            />
          </FormGroup>
          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel>Course Code</FormLabel>
            <TextInput
              id="inputcourseCodesearch"
              name="courseCode"
              value={this.state.searchModel.courseCode || ''}
              onChange={this.handleChangeSearch}
              placeholder="Input Training Course Code"
              type="text"
              labelText=""
              className="bx--text-input some-class bx--text-input--light"
            />
          </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel>Email Compiler</FormLabel>
            <TextInput
              id="inputsearchcompiler"
              name="compiler"
              value={this.state.searchModel.compiler || ''}
              onChange={this.handleChangeSearch}
              placeholder="Input Compiler"
              type="text"
              labelText=""
              className="bx--text-input some-class bx--text-input--light"
            />
          </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel>Email Data Approver</FormLabel>
            <TextInput
              id="inputsearchdataApprover"
              name="dataApprover"
              value={this.state.searchModel.dataApprover || ''}
              onChange={this.handleChangeSearch}
              placeholder="Input Data Approver"
              type="text"
              labelText=""
              className="bx--text-input some-class bx--text-input--light"
            />
          </FormGroup>

          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel>Email Consolidator</FormLabel>
            <TextInput
              id="inputsearchdivisionManager"
              name="divisionManager"
              value={this.state.searchModel.divisionManager || ''}
              onChange={this.handleChangeSearch}
              placeholder="Input Consolidator"
              type="text"
              labelText=""
              className="bx--text-input some-class bx--text-input--light"
            />
          </FormGroup>
          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            {/* RITM0945977 */}
            {/* <FormLabel className="some-class">Division</FormLabel> */}
            <FormLabel className="some-class">Business Line</FormLabel>
            {this.state.isLoadingMainDivision ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="idSearchDivision"
                placeholder="All"
                name="idDivision"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={this.state.searchModel.idMainDivision ? filterItems.idMainDivision : 'All'}
                selectedItem={this.state.searchModel.idMainDivision ? filterItems.idMainDivision : 'All'}
                items={this.state.maindivision}
              />
            )}
          </FormGroup>
          <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
            <FormLabel className="some-class">Month</FormLabel>
            <ComboBox
              id="idSearchMonth"
              placeholder="All"
              name="month"
              alt="searchModel"
              onChange={this.handleChangeMonth}
              itemToString={(item) => (item || '')}
              selectedItem={this.state.searchModel.month ? this.state.month[this.state.searchModel.month - 1] : 'All'}
              items={this.state.month}
              disabled={this.state.searchModel.year == null}
            />
          </FormGroup>
        </Form>
        <div className="searchFormFooter">
          <Button
            className="button--max-width"
            size="small"
            kind="secondary"
            onClick={this.handleClickCancelSearch}
          >
            Cancel
          </Button>
          <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
            Search
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const headersDataTable = [
      { key: 'status', header: 'Status', type: 'status' },
      { key: 'code', header: 'Code' },
      { key: 'workSite', header: 'Worksite' },
      { key: 'project', header: 'Project' },
      { key: 'startDate', header: 'Start Date', type: 'date' },
      { key: 'endDate', header: 'End Date', type: 'date' },
      { key: 'courseCode', header: 'Course Code' },
    ];
    // ///ROWS
    const rowsTrainings =
      this.state.itemList || []
        ? this.state.itemList.map((item) => {
            const result = {};
            result.workSite = item.workSite;
            result.status = item.status;
            result.idStatus = item.idStatus;
            result.code = item.code;
            result.project = item.project;
            result.startDate = item.startDate;
            result.endDate = item.endDate;
            result.trainingCentre = item.trainingCenter?.name;
            result.courseCode = item.info.courseCode;
            result.id = item.id;
            return result;
          })
        : null;
    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });

    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : 5;

    const fileDownLoadButtonProps = (id) => {
      const item = (this.state.itemList || []).find((i) => i.id === id);
      return {
        size: 'small',
        className: 'bx--export-tab-form',
        iconDescription: 'Download Report',
        title: 'Download Report',
        kind: 'ghost',
        apiUrl: `/training/${id}/exportReport`,
        fileName: `Training_${item ? item.code : ''}.pdf`,
        onDownLoadStart: () => {
          this.setState({
            isLoadingNotificationFile: true,
          });
        },
        onDownLoadEnd: () => {
          this.setState({
            isLoadingNotificationFile: false,
          });
        },
        onError: (error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.TRAINING, apioperation.DOWNLOAD)
          );
        },
      };
    };

    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb linkTo="/modules" linkText="Modules" titleLeft="Trainings" />
            <div className="mainContainer">
              <Loading active={this.state.isLoadingNotificationFile} withOverlay />
              <WFActionModal
                show={this.state.isApprovalModalOpen}
                title={`${this.state.approvalModalAction} Trainings`}
                action={this.state.approvalModalAction}
                withApprover={this.state.withApprover}
                approver={this.state.approver}
                approverRole={this.state.approverRole}
                approverOptions={this.state.approvers}
                isLoadingOperation={this.state.isLoadingWFOperation}
                onApproverSelect={this.handleApproverSelect}
                isLoadingOptions={this.state.isLoadingApproverOptions}
                onCancel={this.handleCloseApprovalModal}
                onConfirm={this.handleConfirmApprovalModal}
                onApprovalNotesChange={this.handleApprovalNotesChange}
                approvalNotes={this.state.approvalNotes}
                approvalNotesRequired={this.state.approvalNotesRequired}
                validationMessages={this.state.approvalValidationMessages}
              />
              <div className="header-custom-toolbar">
                <TableToolbar>
                  <Search
                    readOnly
                    light
                    className="search cursor-pointer hiddenSearch"
                    labelText="Search"
                    placeHolderText="Search"
                    id="search-1"
                    onClick={this.toggleSearchForm}
                  />
                  <Button
                    onClick={this.toggleSearchForm}
                    className="buttonPaddingIcon"
                    renderIcon={Data16}
                    iconDescription="Filter"
                  />
                  {IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') ? (
                    <Link to="/training/new">
                      <Button renderIcon={Add20}>New </Button>
                    </Link>
                  ) : null}
                </TableToolbar>
              </div>
              <h4 className="description-page bx--col-lg-8">
                Current year
                <Dropdown
                  id="idSearchYear"
                  label=""
                  name="year"
                  alt="searchModel"
                  items={this.state.trainingYear /* this.state.yearsList */}
                  onChange={this.handleChangeDropDownYear /* this.onYearChange */}
                  initialSelectedItem={this.year.toString()}
                  selectedItem={this.state.searchModel.year ? 
                                this.state.searchModel.year.toString() : 
                                this.year.toString()}
                  itemToString={(item) => item || ''}
                  type="inline"
                />
              </h4>

              {!this.state.isOpenSearchForm ? '' : this.renderSearchform()}

              <DataTable
                rows={rowsTrainings || []}
                headers={headersDataTable}
                useZebraStyles
                size="compact"
                render={({
                  rows,
                  headers,
                  getHeaderProps,
                  getRowProps,
                  /* getTableProps, */
                  getSelectionProps,
                  selectedRows,
                  getBatchActionProps,
                }) => (
                  <TableContainer className="bx--grid--full-width" title="">
                    {selectedRows.length > 0 ? (
                      <Online>
                        <TableToolbar>
                          <TableToolbarContent>
                            <TableBatchActions {...getBatchActionProps()}>
                              {CanExecuteAction(
                                'Training',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Submit',
                                this.getTraining(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Send16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Submit',
                                      'Submit',
                                      'Data Approver',
                                      true,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Submit Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Training',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Approve',
                                this.getTraining(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={CheckmarkOutline16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Approve',
                                      'Approve',
                                        null, /* RUOLI_APPROVATIVI_DEV_255_RITM0565449 */
                                        false, /* RUOLI_APPROVATIVI_DEV_255_RITM0565449 */
                                        false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Approve Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Training',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Consolidate',
                                this.getTraining(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={CheckmarkOutline16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Consolidate',
                                      'Consolidate',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Consolidate Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Training',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Reject',
                                this.getTraining(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Error16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Reject',
                                      'Reject',
                                      null,
                                      false,
                                      true,
                                      selectedRows
                                    )
                                  }
                                >
                                  Reject Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Training',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'RejectConsolidate',
                                this.getTraining(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Error16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'RejectConsolidate',
                                      'Reject',
                                      null,
                                      false,
                                      true,
                                      selectedRows
                                    )
                                  }
                                >
                                  Reject Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Training',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Delete',
                                this.getTraining(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Delete16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Delete',
                                      'Delete',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Delete
                                </TableBatchAction>
                              ) : null}
                            </TableBatchActions>
                          </TableToolbarContent>
                        </TableToolbar>
                      </Online>
                    ) : (
                      ''
                    )}

                    {this.state.isLoading ? (
                      <div className="data-table-skeleton-no-headers">
                        <DataTableSkeleton
                          headers={[]}
                          rowCount={skeletonRowCount}
                          columnCount={headers.length + 1}
                          zebra={false}
                          compact={false}
                        />
                      </div>
                    ) : (
                      <Table>
                        <TableHead>
                          <TableRow>
                            {/* <TableSelectAll {...getSelectionProps()} /> */}
                            <TableHeader className="align-center" />

                            {headers.map((header) => (
                              <TableHeader
                                className={header.type === 'bool' ? 'align-center' : ''}
                                {...getHeaderProps({ header })}
                              >
                                <div
                                  className="sortable-header"
                                  onClick={() => this.handleOrderByChange(header.key)}
                                  role="button"
                                  tabIndex={0}
                                >
                                  <span className="header-title">{header.header}</span>
                                  <SortIcon
                                    show={this.state.searchModel.orderByField === header.key}
                                    isOrderDescending={this.state.searchModel.isOrderDescending}
                                  />
                                </div>
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length === 0 ? (
                            <NoRecordsPlaceholder colSpan={headers.length + 2} />
                          ) : (
                            rows.map((row) => (
                              <TableRow {...getRowProps({ row })}>
                                {this.IsRowSelectable(row, selectedRows, user) ? (
                                  <>
                                    <Online>
                                      <TableSelectRow {...getSelectionProps({ row })} />
                                    </Online>
                                    {' '}
                                    <Offline>
                                      <TableSelectRow disabled />
                                    </Offline>
                                  </>
                                ) : (
                                  <TableCell
                                    key={`empty${row.id}`}
                                    className="tableActions align-center"
                                  />
                                )}

                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}

                                <TableCell
                                  key={`action-${row.id}`}
                                  className="tableActions align-center"
                                >
                                  <div>
                                    <Online>
                                      <FileDownLoadButton
                                        {...fileDownLoadButtonProps(row.id)}
                                        renderIcon={DocumentExport16}
                                      />
                                    </Online>
                                    <Link to={`/training/${row.id}`}>
                                      <Button
                                        size="small"
                                        renderIcon={Edit16}
                                        iconDescription="Edit"
                                        title="Edit Training"
                                        kind="ghost"
                                      />
                                    </Link>

                                    {/* <Button onClick={() => 
                                      this.confirmDelete(row.id)} 
                                      size="small" 
                                      renderIcon={Delete16} 
                                      iconDescription="Delete" 
                                      kind="ghost" /> */}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                )}
              />

              <div className="footer-pagination">
                <Pagination {...paginationProps()} />
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
TrainingList.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string,
    key: PropTypes.string,
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};
